<template>
    <div class="playbook-type-editor mx-2" >
        <div class="asset-type-overview">
        	<h1>{{local_asset_type.id? 'Update': 'Add'}} Channel</h1>

            <div class="card mt-3 ">
                <div class="card-body">
                    <div class="row">
                        <div class="col-5 mb-3">
                            <label class="form-label">Name</label>
                            <input type="text" id="name-input" class="form-control" v-model="local_asset_type.name"
                                :class="((errors.name != '' )? 'is-invalid':'')" @change="clearErrorForField('name')" aria-label="Name">
                            <div class="text-danger invalid-feedback" v-if="errors.name != ''">
                                {{errors.name}}
                            </div>
                        </div>

                        <div class="col-4 mb-3">
                            <label class="form-label"><a href='https://fontawesome.com/search' target="_blank">Icon Class</a></label>
                            <input type="text" id="icon-class-input" class="form-control" v-model="local_asset_type.icon_class"
                                :class="((errors.icon_class != '' )? 'is-invalid':'')" @change="clearErrorForField('icon_class')" aria-label="Icon Class">
                            <div class="text-danger invalid-feedback" v-if="errors.icon_class != ''" v-html="errors.icon_class">
                            </div>
                        </div>
                        <div class="col-3 mb-3">
                            <label class="form-label">Has a Launch Date?
                                <img class="info-icon" src="/img/icons/avid-icons/info.svg" title="Does this asset have a launch date or does it need to be ready when the playbook launches?" data-bs-toggle="tooltip" alt="" ></img>
                            </label>
                            <select class="form-select" v-model="local_asset_type.has_launch_date"
                                :class="((errors.has_launch_date != '' )? 'is-invalid':'')" @change="clearErrorForField('has_launch_date')" aria-label="Has Launch Date">
                                <option value="0">No</option>
                                <option value="1">Yes</option>
                            </select>
                            <div class="text-danger invalid-feedback" v-if="errors.has_launch_date != ''" v-html="errors.has_launch_date">
                            </div>
                        </div>

                        <div class="col-12">
                            <label class="form-label">Description</label>
                            <textarea id="report-description" class="form-control full-height" :class="((errors.description != '' )? 'is-invalid':'')"
                            v-model="local_asset_type.description" ref="textarea"  @input="resizeTextarea()" @change="clearErrorForField('description')"></textarea>
                            <div class="text-danger invalid-feedback" v-if="errors.description != ''">
                                {{errors.description}}
                            </div>
                        </div>

                        <div class="col-12 mt-3">
                            <label class="form-label">Explanation (WYSIWYG)</label>
                            <WysiwygEditorAdvanced
                                :input_value="local_asset_type.explanation || ''"
                                :asset_id="local_asset_type.id || 'new'"
                                :if_allow_edit="true"
                                @wysiwygValueChange="onExplanationChange"
                            />
                        </div>
					</div>
                </div>
            </div>

			<div class="mb-4">
                <div class="row mt-4 align-items-center">

                    <div class="col d-flex align-items-center mb-2">
                        <h3 class="mb-0">
                            Channel Inputs
                        </h3>
                    </div>
                    <div class="col text-end mb-2">
                        <button class="btn btn-primary" id="add-section-button" @click.prevent="addAssetInput" :disabled="form.busy">
                            <i class="fa fa-plus"></i> Add Input Field
                        </button>
                    </div>
                </div>

				<div v-if="local_asset_type.inputs && local_asset_type.inputs.length === 0">
					<div class="card mb-3">
						<div class="card-body mt-3 text-center">
							<h2 class="text-center">No inputs have been added yet.</h2>
							<button type="submit" class="btn btn-secondary" id="add-section-button" @click.prevent="addAssetInput" :disabled="form.busy">
								<i class="fa fa-plus"></i> Add an Input
							</button>
						</div>
					</div>
				</div>

                <draggable v-model="local_asset_type.inputs" handle=".handle" @change="handleDragChange" item-key="id">
                    <template #item="{element: input, index}">
                        <div class="mb-3">
                            <div class="card mx-0" :class="[input.if_active ?'active-section' : ' box-content', input.group_id ? 'ms-4' : '']">
                                <div class="card-body px-1">
                                    <div class="accordion accordion-flush">
                                        <div class="accordion-item border-0 bg-white">
                                            <div class="d-flex align-items-center">
                                                <div class="accordion-header ms-2 flex-grow-1" @click.prevent="setActiveInputSection(index)">
                                                    <button class="text-start collapsed p-2 accordion-button section-accordion-button" type="button"
                                                        :data-bs-target="'#section-editing-' + input.id" data-bs-toggle="collapse"
                                                        aria-expanded="false" :aria-controls="'section-editing-' + input.id" @click="resizeTextareaExpanding(index)">
                                                        <h3 class="mb-1">
                                                            <div class="handle float-start me-2">
                                                                <img src="/img/icons/avid-icons/vertical-dots.svg" alt="drag" class="icon">
                                                            </div>
                                                            <i class="fas fa-circle-exclamation text-danger" v-if="!errors.inputs || !errors.inputs['i'+input.id] || Object.values(errors.inputs['i'+input.id]).join('') != ''"></i>
                                                            {{ input.type === 'group' ? 'Group: ' : 'Input: ' }}{{ input.name? input.name: 'New Input (unsaved)' }}
                                                        </h3>
                                                    </button>
                                                </div>
                                                <div class="d-flex me-2">
                                                    <button v-if="input.type === 'group'" type="button" class="btn btn-none me-0" @click.prevent="addInputToGroup(input.id)" :disabled="form.busy">
                                                        <i class="fa fa-plus me-0"></i>
                                                    </button>
                                                    <button type="submit" class="btn btn-primary me-0" @click.prevent="deleteAssetInput(index)" :disabled="form.busy">
                                                        <img src="/img/icons/avid-icons/trash.svg"class="icon" alt="">
                                                    </button>
                                                </div>
                                            </div>
                                            <div :id="'section-editing-' + input.id" class="collapse accordion-collapse section-accordion-collapse">
                                                <div class="mx-4">
                                                    <hr class="mb-4 section-divider">

                                                    <div class="row">
                                                        <div class="col-12 mb-3">
                                                            <label class="form-label">Name *</label>
                                                            <input type="text" id="name-input" class="form-control" v-model="input.name"
                                                                :class="((errors.inputs && errors.inputs['i' + input.id] && errors.inputs['i' + input.id].name != '' )? 'is-invalid':'')" @change="clearErrorForInputField('i' + input.id, 'name')" aria-label="Name *">
                                                            <div class="text-danger invalid-feedback" v-if="errors.inputs && errors.inputs['i'+input.id] && errors.inputs['i'+input.id].name != ''">
                                                                {{errors.inputs['i'+input.id].name}}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-12 mb-3">
                                                            <label class="form-label">Description</label>
                                                            <textarea id="report-description" class="form-control full-height" v-model="input.description" ref="textarea" @input="resizeTextarea()" ></textarea>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col mb-3" v-if="availableGroups.length > 0 && input.type !== 'group'">
                                                            <label class="form-label">Group</label>
                                                            <div class="d-flex">
                                                                <select class="form-select" v-model="input.group_id" @change="handleGroupChange(input)" aria-label="Group">
                                                                    <option :value="null">No Group</option>
                                                                    <option v-for="group in availableGroups" :key="group.id" :value="group.id">
                                                                        {{ group.name }}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col mb-3">
                                                            <label class="form-label">Type *</label>
                                                            <div class="d-flex">
                                                                <select class="form-select"  v-model="input.type" :class="((errors.inputs && errors.inputs['i'+input.id] && errors.inputs['i'+input.id].type != '' )? 'is-invalid':'')"
                                                                @change="changeInputType(index)" aria-label="Type *">
                                                                    <option value="dropdown">Dropdown</option>
                                                                    <option value="file">File Upload</option>
                                                                    <option value="group" v-if="input.group_id == null">Group</option>
                                                                    <option value="image">Image Upload</option>
                                                                    <option value="link">Link</option>
                                                                    <option value="text">Text</option>
                                                                    <option value="textarea">Textarea</option>
                                                                    <option value="wysiwyg">WYSIWYG</option>
                                                                </select>
                                                            </div>
                                                            <div class="text-danger invalid-feedback" v-if="errors.inputs && errors.inputs['i'+input.id] && errors.inputs['i'+input.id].type != ''">
                                                                {{errors.inputs['i'+input.id].type}}
                                                            </div>
                                                        </div>

                                                        <div class="col mb-3" v-if="input.type == 'text' || input.type== 'textarea'">
                                                            <label class="form-label">Maximum Number of Characters</label>
                                                            <input type="number" id="name-input" class="form-control" v-model="input.max_length" aria-label="Maximum Number of Characters">
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-12 mb-3" v-if="input.type == 'dropdown'">
                                                            <label class="form-label">Options *
                                                                <button type="submit" class="btn btn-white ms-2" @click.prevent="addOption(index)" :disabled="form.busy">
                                                                    <i class="fa fa-plus me-0"></i>
                                                                </button>
                                                            </label>
                                                            <div v-for="(_, o_i) in input.options" :key="o_i" class="d-flex mb-1">
                                                                <span class="me-2 mt-2">{{ o_i + 1 }}. </span>
                                                                <input type="text" id="name-input" class="form-control" v-model="input.options[o_i]"  aria-label="Options[o I]">
                                                                <button type="submit" class="btn btn-none ms-2" v-if="input.options.length > 1" @click.prevent="removeOption(index, o_i)" :disabled="form.busy">
                                                                    <img class="icon" src="/img/icons/avid-icons/trash.svg" alt="" >
                                                                </button>
                                                            </div>
                                                            <div class="text-danger invalid-feedback" v-if="errors.inputs && errors.inputs['i'+input.id] && errors.inputs['i'+input.id].options != ''">
                                                                {{errors.inputs['i'+input.id].options}}
                                                            </div>
                                                        </div>
                                                        
                                                        <div class="col-12 mb-3" v-if="input.type == 'image'">
                                                            <label class="form-label">Image Ratios
                                                                <img class="info-icon" src="/img/icons/avid-icons/info.svg" title="Aspect ratios for generated images (e.g., 16:9, 1:1, 4:5)" data-bs-toggle="tooltip" alt=""></img>
                                                                <button type="submit" class="btn btn-white ms-2" @click.prevent="addImageRatio(index)" :disabled="form.busy">
                                                                    <i class="fa fa-plus me-0"></i>
                                                                </button>
                                                            </label>
                                                            <div v-for="(ratio, r_i) in getImageRatios(input)" :key="r_i" class="d-flex mb-1">
                                                                <span class="me-2 mt-2">{{ r_i + 1 }}. </span>
                                                                <select class="form-select" v-model="input.image_ratios[r_i]" aria-label="Image Ratios[r I]">
                                                                    <option value="1:1">1:1 (Square)</option>
                                                                    <option value="2:3">2:3</option>
                                                                    <option value="3:2">3:2</option>
                                                                    <option value="3:4">3:4</option>
                                                                    <option value="4:3">4:3</option>
                                                                    <option value="4:5">4:5</option>
                                                                    <option value="5:4">5:4</option>
                                                                    <option value="9:16">9:16 (Vertical)</option>
                                                                    <option value="16:9">16:9 (Landscape)</option>
                                                                    <option value="21:9">21:9 (Ultra-wide)</option>
                                                                </select>
                                                                <button type="submit" class="btn btn-none ms-2" v-if="getImageRatios(input).length > 1" @click.prevent="removeImageRatio(index, r_i)" :disabled="form.busy">
                                                                    <img class="icon" src="/img/icons/avid-icons/trash.svg" alt="" >
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-12 mb-3">
                                                            <div class="form-check">
                                                                <input type="checkbox" class="form-check-input" v-model="input.optional" :id="'optional-' + input.id" aria-label="Optional">
                                                                <label class="form-check-label" :for="'optional-' + input.id">
                                                                    Optional <img class="info-icon" src="/img/icons/avid-icons/info.svg" title="This means that the input may or may not be generated by the AI" data-bs-toggle="tooltip" alt="" ></img>
                                                                </label>
                                                            </div>
                                                            <div class="form-check">
                                                                <input type="checkbox" class="form-check-input" v-model="input.repeatable" :id="'repeatable-' + input.id" aria-label="Repeatable">
                                                                <label class="form-check-label" :for="'repeatable-' + input.id">
                                                                    Repeatable <img class="info-icon" src="/img/icons/avid-icons/info.svg" title="This means that the input can be repeated multiple times" data-bs-toggle="tooltip" alt="" ></img>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </draggable>
			</div>
        </div>

        <div v-if="local_asset_type.inputs && local_asset_type.inputs.length >0"  class="row">
            <div class="col-12 navbar navbar-expand">
                <button type="submit" class="btn btn-primary ms-2" id="save-button" @click.prevent="update" :disabled="form.busy">
                    <img class="icon" src="/img/icons/avid-icons/save.svg" alt=""> Save
                </button>
                <button class="btn btn-secondary ms-2" @click.prevent="backToPlaybookTypeList()" :disabled="form.busy">
                    Back
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import draggable from 'vuedraggable';
import Swal from 'sweetalert2';
import vSelect from "vue3-select";
import WysiwygEditorAdvanced from '../../components/WysiwygEditorAdvanced.vue';
import { useNotifications } from '../../../composables/useNotifications';

export default defineComponent({
    components: { draggable, Swal, vSelect, WysiwygEditorAdvanced },
    setup() {
        const { showNotification } = useNotifications();
        return {
            showNotification
        };
    },
    props: {
        asset_type: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            local_asset_type: {},
            errors: {
                name: '',
                icon_class: '',
                has_launch_date: '',
                description: '',
                explanation: '',
                inputs: {}
            },
            active_input_section: {},
            form: {
                successful: false,
                busy: false,
                error: false
            },
            if_changes_made: false
        };
    },
    computed: {
        availableGroups() {
            return this.local_asset_type.inputs.filter(input => input.type === 'group');
        }
    },
    beforeMount() {
        this.local_asset_type = { ...this.asset_type };

        // Ensure inputs array is initialized
        if (!this.local_asset_type.inputs) {
            this.local_asset_type.inputs = [];
        }

        // Ensure errors.inputs is initialized as an object
        if (!this.errors.inputs) {
            this.errors.inputs = {};
        }

        // Add an error object for each input and ensure image_ratios is properly initialized
        this.local_asset_type.inputs.forEach((input) => {
            if (input && input.id) {
                this.errors.inputs['i' + input.id] = this.getInputErrorObj();
            }
            // Ensure image_ratios is properly initialized as an array if it's an image input
            if (input && input.type === 'image') {
                if (!input.image_ratios) {
                    input.image_ratios = ['16:9'];
                } else if (typeof input.image_ratios === 'string') {
                    try {
                        input.image_ratios = JSON.parse(input.image_ratios);
                    } catch (e) {
                        input.image_ratios = ['16:9'];
                    }
                }
                if (!Array.isArray(input.image_ratios)) {
                    input.image_ratios = ['16:9'];
                }
            }
        });
    },
    mounted() {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl));

        for (let i = 0; i < tooltipTriggerList.length; i++) {
            (function(index) {
                tooltipTriggerList[index].addEventListener('click', function() {
                  // Hide the tooltip using the index passed to the closure
                    tooltipList[index].hide();
                });
                tooltipTriggerList[index].addEventListener('mouseleave', function() {
                  // Hide the tooltip using the index passed to the closure
                    tooltipList[index].hide();
                });
            })(i);
        }
    },
    beforeUnmount() {
        // Clean up tooltips
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        tooltipTriggerList.forEach(tooltipTriggerEl => {
            const tooltip = window.bootstrap.Tooltip.getInstance(tooltipTriggerEl);
            if (tooltip) {
                tooltip.dispose();
            }
        });
    },
    methods: {
        onExplanationChange({ value }) {
            this.local_asset_type.explanation = value;
            this.if_changes_made = true;
        },
        revertOverviewChange(){
            if(this.asset_type.name != null) {
                this.local_asset_type.name = this.asset_type.name;
                this.local_asset_type.icon_class = this.asset_type.icon_class;
                this.local_asset_type.description = this.asset_type.description;
            }
            this.is_editing_asset_type_overview =false;
        },
        clearErrorForField(field_name){
            this.errors[field_name] = '';
        },
        clearErrorForInputField(index, field_name){
            if (this.errors.inputs && this.errors.inputs[index]) {
                this.errors.inputs[index][field_name] = '';
            }
        },
        resizeTextarea() {
            var element = document.querySelectorAll('textarea')[0];
            if (element && element.style){
                element.style.height = '';
                element.style.height = Math.max(element.offsetHeight, element.scrollHeight) + "px";
            }
        },
        optionalToggle(index){
            this.local_asset_type.inputs[index].optional = !this.local_asset_type.inputs[index].optional;
            this.$forceUpdate();
        },
        hasErrors() {//validate the form
            // Error checking for overview section
            if(this.local_asset_type.name == null || this.local_asset_type.name == ""){
                this.errors.name = "A name is required.";
            } else
                this.errors.name = "";


            if(this.local_asset_type.icon_class == null || this.local_asset_type.icon_class == ""){
                this.errors.icon_class = "An icon class is required.";
            }
            else
                this.errors.icon_class = "";

            if(this.local_asset_type.has_launch_date == null || this.local_asset_type.has_launch_date == ""){
                this.local_asset_type.has_launch_date = false;
            }

            if(this.local_asset_type.description == null || this.local_asset_type.description == ""){
                this.errors.description = "A description is required.";
            } else
                this.errors.description = "";


            var if_input_has_error = false;
            if (this.local_asset_type.inputs && this.local_asset_type.inputs.length>0){
                this.local_asset_type.inputs.forEach((input)=>{
                    if(!input.name || input.name.trim() == ""){
                        this.errors.inputs['i'+input.id].name = "A name is required.";
                    } else {
                        this.errors.inputs['i'+input.id].name = "";
                    }
                    if(!input.type || input.type.trim() == ""){
                        this.errors.inputs['i'+input.id].type = "A type is required.";
                    }
                    else {
                        this.errors.inputs['i'+input.id].type = "";
                    }
                    if(input.type == 'dropdown' && (!input.options || input.options.length == 0 || input.options.includes(""))){
                        this.errors.inputs['i'+input.id].options = "Options are required for dropdown field and option values cannot be empty.";
                    }
                    else {
                        this.errors.inputs['i'+input.id].options = "";
                    }
                })

                if_input_has_error = this.checkIfInputHasError();
            }

            if (this.errors.name != "" || this.errors.icon_class!="" || this.errors.has_launch_date!="" || this.errors.description!="" || if_input_has_error){
                return true
            } else {
                return false
            }
        },
        checkIfInputHasError(){
            let has_error = false;
            //Loop through the input errors (it is an object, not an array)
            //
            Object.keys(this.errors.inputs).forEach((key)=>{
                if(Object.values(this.errors.inputs[key]).join('') != ''){
                    has_error = true;
                }
            });

            return has_error;
        },
        getInputErrorObj() {
            return {
                name: '',
                type: '',
                max_length: '',
                options: ''
            };
        },
        addAssetInput(){
            var new_asset_input = this.createNewAssetInput();
            this.local_asset_type.inputs.push(new_asset_input);

            this.errors.inputs["i"+new_asset_input.id] = this.getInputErrorObj();

            this.if_changes_made = true;

            // Close all current sections
            const collapsableSections = document.querySelectorAll('.section-accordion-collapse');
            const collapsableSectionAccordionButtons = document.querySelectorAll('.section-accordion-button');

            for(var i = 0; i < this.local_asset_type.inputs.length; i++){
                collapsableSections[i]?.classList.remove('show');
                collapsableSectionAccordionButtons[i]?.classList.add('collapsed');
                this.local_asset_type.inputs[i].if_active = false;
            }

            // Expand the new input
            this.$nextTick(() => {
                // Find the index of the new input
                const newIndex = this.local_asset_type.inputs.findIndex(input => input.id === new_asset_input.id);
                if (newIndex !== -1) {
                    this.setActiveInputSection(newIndex);

                    // Manually trigger the collapse/expand
                    const newSection = document.querySelector(`#section-editing-${newIndex}`);
                    const newButton = document.querySelector(`[data-bs-target="#section-editing-${newIndex}"]`);
                    if (newSection && newButton) {
                        newSection.classList.add('show');
                        newButton.classList.remove('collapsed');
                    }
                }

                // Reinitialize tooltips
                const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
                const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl));

                for (var i = 0; i < tooltipTriggerList.length; i++) {
                    (function(index) {
                        tooltipTriggerList[index].addEventListener('click', function() {
                            tooltipList[index].hide();
                        });
                        tooltipTriggerList[index].addEventListener('mouseleave', function() {
                            tooltipList[index].hide();
                        });
                    })(i);
                }
            });
        },
        createNewAssetInput(addToGroup = false){
            // Only determine group if addToGroup is true
            let groupId = null;

            if (addToGroup) {
                // Find the last input to determine if it should be in a group
                const lastInput = this.local_asset_type.inputs[this.local_asset_type.inputs.length - 1];

                if (lastInput) {
                    if (lastInput.type === 'group') {
                        // If last input is a group, add to that group
                        groupId = lastInput.id;
                    } else if (lastInput.group_id) {
                        // If last input is in a group, add to the same group
                        groupId = lastInput.group_id;
                    }
                }
            }

            const asset_input = {
                id: Math.round(Math.random()*-10000),
                if_active: false,
                playbook_asset_type_id: this.local_asset_type.id,
                name: '',
                description: '',
                type: 'text',
                optional: false,
                repeatable: false,
                group_id: groupId,
                group_temp_id: groupId < 0 ? groupId : null,
                max_length: null,
                options: null,
                order: this.local_asset_type.inputs.length + 1
            };

            this.if_changes_made = true;
            return asset_input;
        },

        changeInputType(index){
            const input = this.local_asset_type.inputs[index];
            this.clearErrorForInputField('i'+input.id, 'type');

            // Handle dropdown options
            if(input.type == 'dropdown' && (!input.options || !input.options.length == 0)){
                input.options = [''];
            }
            
            // Handle image ratios
            if(input.type == 'image' && !input.image_ratios){
                input.image_ratios = ['16:9']; // Default ratio
            } else if(input.type != 'image' && input.image_ratios){
                // Clear image ratios if type is changed away from image
                input.image_ratios = null;
            }

            // Handle conversion to group
            if(input.type === 'group') {
                // If converting to a group, remove any group_id
                input.group_id = null;
                input.group_temp_id = null;

                // Move this input before any inputs that might have been in the same group
                const currentIndex = this.local_asset_type.inputs.indexOf(input);

                // Find all inputs that were in the same group as this input
                const groupedInputs = this.local_asset_type.inputs.filter(i =>
                    i.group_id === input.id
                );

                // If there are any inputs in this group, we need to reorder them
                if (groupedInputs.length > 0) {
                    // Remove all grouped inputs from their current positions
                    groupedInputs.forEach(groupedInput => {
                        const inputIndex = this.local_asset_type.inputs.indexOf(groupedInput);
                        if (inputIndex !== -1) {
                            this.local_asset_type.inputs.splice(inputIndex, 1);
                        }
                    });

                    // Insert grouped inputs after the group
                    this.local_asset_type.inputs.splice(currentIndex + 1, 0, ...groupedInputs);
                }
            } else if (input.group_id) {
                // If converting from a group, handle any inputs that were in this group
                const inputsInGroup = this.local_asset_type.inputs.filter(i => i.group_id === input.id);

                // Move these inputs out of the group
                inputsInGroup.forEach(groupedInput => {
                    groupedInput.group_id = input.group_id;
                    groupedInput.group_temp_id = input.group_temp_id;
                });
            }

            this.if_changes_made = true;
            this.$forceUpdate();
        },
        addOption(input_field_index, isGrouped = false){
            if (isGrouped) {
                // For grouped inputs, find the actual input in the main array
                const groupedInput = this.local_asset_type.inputs.find(input => input.id === input_field_index);
                if (groupedInput) {
                    if (!groupedInput.options) {
                        groupedInput.options = [''];
                    } else {
                        groupedInput.options.push('');
                    }
                }
            } else {
                // For main inputs
                if (!this.local_asset_type.inputs[input_field_index].options) {
                    this.local_asset_type.inputs[input_field_index].options = [''];
                } else {
                    this.local_asset_type.inputs[input_field_index].options.push('');
                }
            }
        },
        removeOption(input_field_index, option_index, isGrouped = false){
            if (isGrouped) {
                // For grouped inputs, find the actual input in the main array
                const groupedInput = this.local_asset_type.inputs.find(input => input.id === input_field_index);
                if (groupedInput && groupedInput.options) {
                    groupedInput.options.splice(option_index, 1);
                }
            } else {
                // For main inputs
                this.local_asset_type.inputs[input_field_index].options.splice(option_index, 1);
            }
        },
        getImageRatios(input) {
            if (!input.image_ratios) {
                input.image_ratios = ['16:9']; // Default ratio
            }
            // Ensure it's an array
            if (typeof input.image_ratios === 'string') {
                try {
                    input.image_ratios = JSON.parse(input.image_ratios);
                } catch (e) {
                    input.image_ratios = ['16:9'];
                }
            }
            if (!Array.isArray(input.image_ratios)) {
                input.image_ratios = ['16:9'];
            }
            return input.image_ratios;
        },
        addImageRatio(input_index) {
            const input = this.local_asset_type.inputs[input_index];
            if (!input.image_ratios) {
                input.image_ratios = [];
            }
            // Ensure it's an array
            if (typeof input.image_ratios === 'string') {
                try {
                    input.image_ratios = JSON.parse(input.image_ratios);
                } catch (e) {
                    input.image_ratios = [];
                }
            }
            if (!Array.isArray(input.image_ratios)) {
                input.image_ratios = [];
            }
            // Add default ratio if empty, otherwise add another
            if (input.image_ratios.length === 0) {
                input.image_ratios.push('16:9');
            } else {
                input.image_ratios.push('16:9');
            }
            this.if_changes_made = true;
        },
        removeImageRatio(input_index, ratio_index) {
            const input = this.local_asset_type.inputs[input_index];
            if (input.image_ratios && Array.isArray(input.image_ratios)) {
                input.image_ratios.splice(ratio_index, 1);
                // If no ratios left, set to null
                if (input.image_ratios.length === 0) {
                    input.image_ratios = null;
                }
            }
            this.if_changes_made = true;
        },
        deleteAssetInput(index, isGrouped = false){
            Swal.fire({
              title: "Are you sure you want to delete the input field?",
              text: "Once saving the current Channel, this input field will be removed from it and all Campaign Types associated with it.",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes, delete",
              customClass: {
                popup: 'swal-warning'
              },
            }).then((result) => {
                if (result.isConfirmed) {
                    if (isGrouped) {
                        // For grouped inputs, find the actual input in the main array
                        const groupedInput = this.local_asset_type.inputs.find(input => input.id === index);
                        if (groupedInput) {
                            this.errors.inputs['i'+groupedInput.id] = this.getInputErrorObj();
                            const inputIndex = this.local_asset_type.inputs.indexOf(groupedInput);
                            if (inputIndex !== -1) {
                                this.local_asset_type.inputs.splice(inputIndex, 1);
                            }
                        }
                    } else {
                        // For main inputs
                        const inputToDelete = this.local_asset_type.inputs[index];

                        // If this is a group, delete all inputs in the group
                        if (inputToDelete.type === 'group') {
                            // Find all inputs that belong to this group
                            const inputsToDelete = this.local_asset_type.inputs.filter(input => input.group_id === inputToDelete.id);

                            // Delete all inputs in the group
                            inputsToDelete.forEach(input => {
                                this.errors.inputs['i'+input.id] = this.getInputErrorObj();
                                const inputIndex = this.local_asset_type.inputs.indexOf(input);
                                if (inputIndex !== -1) {
                                    this.local_asset_type.inputs.splice(inputIndex, 1);
                                }
                            });
                        }

                        // Delete the input itself (or the group)
                        this.errors.inputs['i'+inputToDelete.id] = this.getInputErrorObj();
                        this.local_asset_type.inputs.splice(index, 1);
                    }
                    this.if_changes_made = true;

                    this.showNotification({
                        text: 'Input field was deleted!'
                    });
                }
            });
        },
        setActiveInputSection(index, isGrouped = false){
            var collapsableSections = document.querySelectorAll('.section-accordion-collapse');
            var collapsableSectionAccordionButtons = document.querySelectorAll('.section-accordion-button');

            // Reset all sections first
            for(var i = 0; i < this.local_asset_type.inputs.length; i++){
                collapsableSections[i]?.classList.remove('show');
                collapsableSectionAccordionButtons[i]?.classList.add('collapsed');
                this.local_asset_type.inputs[i].if_active = false;
            }

            // Set the active section
            if (isGrouped) {
                // For grouped inputs, find the actual input in the main array
                const groupedInput = this.local_asset_type.inputs.find(input => input.id === index);
                if (groupedInput) {
                    groupedInput.if_active = true;
                    this.active_input_section = groupedInput;
                }
            } else {
                // For main inputs
                this.local_asset_type.inputs[index].if_active = true;
                this.active_input_section = this.local_asset_type.inputs[index];
            }

            this.$forceUpdate();
        },
        resizeTextareaExpanding(index) {
            if(this.local_asset_type.inputs[index].if_active == true){
                var element = document.querySelectorAll('textarea');

                for(var index = 0; index<element.length; index++){
                    if (element[index] && element[index].style){
                        element[index].style.height = '';
                        element[index].style.height = Math.max(element[index].offsetHeight, element[index].scrollHeight) + "px";
                    }
                }
            }
        },
        update() {
            // Check for frontend validation errors
            if (this.hasErrors()) {
                Swal.fire({
                    title: "Error saving the Channel",
                    text: "There were some issues saving this channel; please review and make the suggested changes.",
                    icon: "error",
                    confirmButtonText: "View Errors",
                    customClass: {
                        popup: 'swal-error'
                    },
                });
                this.$forceUpdate();
                return;
            }

            // Indicate that the form is being submitted
            this.form.busy = true;

            // Then process all inputs with updated group IDs
            const processAllInputs = async () => {

                // Assign the correct order to each input and ensure image_ratios is properly formatted
                if (this.local_asset_type.inputs && this.local_asset_type.inputs.length > 0) {
                    this.local_asset_type.inputs.forEach((input, index) => {
                        input.order = index + 1;
                        
                        // Ensure image_ratios is properly set for image inputs
                        if (input.type === 'image') {
                            // Ensure it's an array (not null, not string)
                            if (!input.image_ratios || !Array.isArray(input.image_ratios)) {
                                input.image_ratios = ['16:9']; // Default if missing
                            }
                        } else {
                            // Clear image_ratios for non-image inputs
                            input.image_ratios = null;
                        }
                    });
                }

                // Determine whether to create a new AssetType or update an existing one
                let axiosRequest;
                if (!this.local_asset_type.id) {
                    axiosRequest = window.axios.post('/api/playbooks/asset_type', 
                        this.local_asset_type);
                } else {
                    axiosRequest = window.axios.put(`/api/playbooks/asset_type/${this.local_asset_type.id}`, 
                        this.local_asset_type);
                }

                return axiosRequest;
            };

            // Execute the save process
            processAllInputs()
                .then((response) => {
                    if (response.data.success) {
                        // Show success SweetAlert and redirect
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: this.local_asset_type.id
                                ? "Channel has been updated successfully!"
                                : "Channel has been created successfully!",
                            confirmButtonText: 'OK',
                            customClass: {
                                popup: 'swal-success'
                            },
                        }).then(() => {
                            // Redirect to the admin list page
                            window.location.href = '/admin/playbooks/list';
                        });
                    } else {
                        // Handle unexpected success response structure
                        Swal.fire({
                            title: "Error saving the Channel",
                            text: "An unexpected error occurred. Please try again.",
                            icon: "error",
                            confirmButtonText: "OK",
                            customClass: {
                                popup: 'swal-error'
                            },
                        });
                    }
                })
                .catch((error) => {
                    // Reset the busy state immediately
                    this.form.busy = false;
                    
                    if (error.response && error.response.status === 422) {
                        // Handle validation errors returned from the API
                        const apiErrors = error.response.data.errors;

                        // Reset current errors
                        this.errors = {
                            name: '',
                            icon_class: '',
                            has_launch_date: '',
                            description: '',
                            inputs: {},
                        };

                        // Iterate through the API errors and map them to the Vue component's errors object
                        Object.keys(apiErrors).forEach((key) => {
                            const messages = apiErrors[key];
                            if (key.startsWith('inputs.')) {
                                // Example key: inputs.0.name
                                const parts = key.split('.');
                                const index = parseInt(parts[1], 10);
                                const field = parts[2];
                                const input = this.local_asset_type.inputs[index];
                                if (input) {
                                    const input_id = input.id;
                                    if (!this.errors.inputs["i"+input_id]) {
                                        this.errors.inputs["i"+input_id] = this.getInputErrorObj();
                                    }
                                    if (field === 'options') {
                                        // Handle dropdown options errors
                                        if (!this.errors.inputs["i"+input_id].options) {
                                            this.errors.inputs["i"+input_id].options = [];
                                        }
                                        messages.forEach((msg, msgIndex) => {
                                            this.errors.inputs["i"+input_id].options[msgIndex] = msg;
                                        });
                                    } else {
                                        this.errors.inputs["i"+input_id][field] = messages.join(' ');
                                    }
                                }
                            } else {
                                // Handle overview field errors
                                this.errors[key] = messages.join(' ');
                            }
                        });

                        // Show validation error SweetAlert
                        Swal.fire({
                            title: "Error saving the channel",
                            text: "There were some issues saving this channel; please review and make the suggested changes.",
                            icon: "error",
                            confirmButtonText: "View Errors",
                            customClass: {
                                popup: 'swal-error'
                            },
                        });
                    } else {
                        // Handle other types of errors
                        Swal.fire({
                            title: "Error saving the channel",
                            text: "An unexpected error occurred. Please try again later.",
                            icon: "error",
                            confirmButtonText: "OK",
                            customClass: {
                                popup: 'swal-error'
                            },
                        });
                    }
                })
                .finally(() => {
                    // Reset the busy state
                    this.form.busy = false;
                });
        },
        handleDragChange(evt) {
            if (evt.moved) {
                const { newIndex } = evt.moved;
                const movedInput = this.local_asset_type.inputs[newIndex];

                // If the moved input is a group, we need to move all its inputs too
                if (movedInput.type === 'group') {
                    // Find all inputs that belong to this group
                    const groupedInputs = this.local_asset_type.inputs.filter(input => input.group_id === movedInput.id);

                    // Remove all grouped inputs from their current positions
                    groupedInputs.forEach(input => {
                        const currentIndex = this.local_asset_type.inputs.indexOf(input);
                        if (currentIndex !== -1) {
                            this.local_asset_type.inputs.splice(currentIndex, 1);
                        }
                    });

                    // Insert grouped inputs after the group in their new position
                    const insertIndex = newIndex + 1;
                    this.local_asset_type.inputs.splice(insertIndex, 0, ...groupedInputs);
                } else {
                    // If this is a regular input, check if it should be in a group

                    // Find the nearest group above the new position
                    let nearestGroup = null;
                    for (let i = newIndex - 1; i >= 0; i--) {
                        const input = this.local_asset_type.inputs[i];
                        if (input.type === 'group') {
                            nearestGroup = input;
                            break;
                        }
                    }

                    // Find the nearest input above the new position
                    let nearestInput = null;
                    if (newIndex > 0) {
                        nearestInput = this.local_asset_type.inputs[newIndex - 1];
                    }

                    // If the nearest input is in a group, add this input to the same group
                    if (nearestInput && nearestInput.group_id && !movedInput.type === 'group') {
                        movedInput.group_id = nearestInput.group_id;
                        movedInput.group_temp_id = nearestInput.group_temp_id;
                    }
                    // If there's a group above and the input is not already in a group and not a group itself
                    else if (nearestGroup && !movedInput.group_id && movedInput.type !== 'group') {
                        // Check if the next input after this one is in the group
                        const nextInput = newIndex < this.local_asset_type.inputs.length - 1 ?
                            this.local_asset_type.inputs[newIndex + 1] : null;

                        if (nextInput && nextInput.group_id === nearestGroup.id) {
                            // If the next input is in the group, add this input to the group
                            movedInput.group_id = nearestGroup.id;
                            movedInput.group_temp_id = nearestGroup.id < 0 ? nearestGroup.id : null;
                        }
                    } else if (!nearestGroup && movedInput.group_id) {
                        // If there's no group above and this input is in a group, check if it should be removed

                        // Check if the next input is in the same group
                        const nextInput = newIndex < this.local_asset_type.inputs.length - 1 ?
                            this.local_asset_type.inputs[newIndex + 1] : null;

                        if (!nextInput || nextInput.group_id !== movedInput.group_id) {
                            // If the next input is not in the same group, remove this input from the group
                            movedInput.group_id = null;
                            movedInput.group_temp_id = null;
                        }
                    }
                }

                // Update order for all inputs
                this.local_asset_type.inputs.forEach((input, index) => {
                    input.order = index + 1;
                });
            }

            this.if_changes_made = true;
            this.$forceUpdate();
        },
        addInputToGroup(groupId) {
            // Create a new input with addToGroup=true
            const newInput = this.createNewAssetInput(true);

            // Set the group ID explicitly
            newInput.group_id = groupId;
            newInput.group_temp_id = groupId < 0 ? groupId : null;

            // Find the last input in this group to determine where to insert
            let lastGroupIndex = this.local_asset_type.inputs.findIndex(i =>
                i.group_id === groupId &&
                (this.local_asset_type.inputs.indexOf(i) === this.local_asset_type.inputs.length - 1 ||
                 this.local_asset_type.inputs[this.local_asset_type.inputs.indexOf(i) + 1]?.group_id !== groupId)
            );

            // If there are no inputs in the group yet, insert after the group
            if (lastGroupIndex === -1) {
                const groupIndex = this.local_asset_type.inputs.findIndex(i => i.id === groupId);
                if (groupIndex !== -1) {
                    lastGroupIndex = groupIndex;
                }
            }

            // Insert the new input after the last input in the group
            if (lastGroupIndex !== -1) {
                this.local_asset_type.inputs.splice(lastGroupIndex + 1, 0, newInput);
            } else {
                // Fallback: just add to the end
                this.local_asset_type.inputs.push(newInput);
            }

            // Add error object for the new input
            this.errors.inputs["i"+newInput.id] = this.getInputErrorObj();

            // Mark changes
            this.if_changes_made = true;

            // Don't open any accordions, just add the input to the group
            this.$nextTick(() => {
                // Reinitialize tooltips
                const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
                const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl));

                for (var i = 0; i < tooltipTriggerList.length; i++) {
                    (function(index) {
                        tooltipTriggerList[index].addEventListener('click', function() {
                            tooltipList[index].hide();
                        });
                        tooltipTriggerList[index].addEventListener('mouseleave', function() {
                            tooltipList[index].hide();
                        });
                    })(i);
                }
            });
        },


        handleGroupChange(input) {
            const currentIndex = this.local_asset_type.inputs.indexOf(input);

            // If the input is being added to a group, move it to the end of that group
            if (input.group_id) {
                const group = this.local_asset_type.inputs.find(i => i.id === input.group_id);
                if (group) {
                    // Find the last input in this group
                    let lastGroupIndex = this.local_asset_type.inputs.findIndex(i =>
                        i.group_id === input.group_id &&
                        (this.local_asset_type.inputs.indexOf(i) === this.local_asset_type.inputs.length - 1 ||
                         this.local_asset_type.inputs[this.local_asset_type.inputs.indexOf(i) + 1]?.group_id !== input.group_id)
                    );

                    if (lastGroupIndex !== -1) {
                        // Move the input after the last input in the group
                        this.local_asset_type.inputs.splice(currentIndex, 1);
                        this.local_asset_type.inputs.splice(lastGroupIndex + 1, 0, input);
                    }
                }
            } else {
                //Find the oldGroupId by looking at the elements before the current index and find the first group
                let oldGroupId = null;
                for (let i = currentIndex - 1; i >= 0; i--) {
                    if (this.local_asset_type.inputs[i].type === 'group') {
                        oldGroupId = this.local_asset_type.inputs[i].id;
                        break;
                    }
                }

                // Move the input after the last input in the old group
                this.local_asset_type.inputs.splice(currentIndex, 1);
                // If the input is being removed from a group, move it below the last input in that group
                let lastGroupIndex = this.local_asset_type.inputs.findIndex(i =>
                    i.group_id === oldGroupId &&
                    (this.local_asset_type.inputs.indexOf(i) === this.local_asset_type.inputs.length - 1 ||
                    this.local_asset_type.inputs[this.local_asset_type.inputs.indexOf(i) + 1]?.group_id !== oldGroupId)
                );

                if (lastGroupIndex !== -1) {
                    this.local_asset_type.inputs.splice(lastGroupIndex+1, 0, input);
                }
                else {
                    this.local_asset_type.inputs.splice(currentIndex, 0, input);
                }
            }

            this.if_changes_made = true;
            this.$forceUpdate();
        },
        backToPlaybookTypeList(){
            window.location.href = '/admin/playbooks/list';
        },
    }
});
</script>
